import _has from 'lodash/has';
import * as Scroll from 'react-scroll';
import createBrowserHistory from 'history/createBrowserHistory';
import Page from './page';
import i18n from './reacti18n';

const scroll = Scroll.animateScroll;

const title = {
  topic: i18n.message('smarthelp/index.topicTitle'),
  article: i18n.message('smarthelp/index.articleTitle'),
  home: i18n.message('smarthelp/index.homeTitle'),
  search: i18n.message('smarthelp/index.searchTitle'),
};

const history = createBrowserHistory({
  basename: `/${Page.getCountry()}/smarthelp`,
});

history.listen((location) => {
  if (location && location.pathname) {
    const paths = location.pathname.split('/');
    const path = paths.length > 0 && paths[2];
    if (_has(title, path)) {
      Page.setDocumentTitle(title[path]);
    }
  }

  // If there is hash in the URL, then the page will not scroll to top
  if (!location.hash) {
    // Scroll to top when switch URL in the HCR
    scroll.scrollToTop({
      duration: 0,
    });
  }
});

const getHistory = () => history;

export default getHistory;
